import { useFetch } from './useFetch';
import { getShortAgents } from '../api';

export const useAgentsOptions = () => {
  const { loading, data, error } = useFetch(async () => {
    const agents = await getShortAgents();
    return (agents ?? []).map(agent => ({
      value: agent.id ?? '',
      label: agent.title ?? '',
    }));
  }, []);

  return {
    agentsOptions: data ?? [],
    isAgentsLoading: loading,
    agentsError: error,
  };
};
